// extracted by mini-css-extract-plugin
export default {"noData":"NoDataMessage_noData__iomhK"};